<template>
    <div>
        <h1>500 Internal Error</h1>
    </div>
</template>